module.exports = __webpack_public_path__ + "static/image_01_b@2x-c83444f3d890bcd3854bc202cdc6229d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/case-studies/trusona/image_01_b@2x.jpg
// module id = 417
// module chunks = 3627797113349 20562973939449 33019919093843